const LOCK_EXPIRATION_MS = 15 * 1000; // 15 sec

export function acquireLock(lockName) {
  const now = Date.now();
  const lockData = localStorage.getItem(lockName);

  if (!lockData) {
    localStorage.setItem(lockName, JSON.stringify({ timestamp: now }));
    return true;
  }

  try {
    const { timestamp } = JSON.parse(lockData);
    if (now - timestamp > LOCK_EXPIRATION_MS) {
      localStorage.setItem(lockName, JSON.stringify({ timestamp: now }));
      return true;
    }
    return false;
  } catch {
    localStorage.setItem(lockName, JSON.stringify({ timestamp: now }));
    return true;
  }
}

export function releaseLock(lockName) {
  localStorage.removeItem(lockName);
}
